export default {
  "navbar.about_app": "关于 APP",
  "navbar.analytics": "分析",
  "navbar.asset_dashboard": "资产",
  "navbar.market_status": "市场",
  "navbar.stock_dashboard": "股票",
  "navbar.indicators": "指标",
};
